import React from 'react';

const CATEGORIES = [
  {
    id: 'veioppdateringer',
    label: 'Veioppdateringer',
    description: 'Sanntidsinformasjon om norske veier og trafikk.',
    color: '#E8630A',
    tag: 'VEI'
  },
  {
    id: 'bomkalkulator',
    label: 'Bomkalkulator tips',
    description: 'Spar penger med smarte bom-ruter og rabatter.',
    color: '#3B6FD4',
    tag: 'BOM'
  },
  {
    id: 'nyheter',
    label: 'Nyheter',
    description: 'Siste nytt fra norsk veiinfrastruktur og samferdsel.',
    color: '#E8630A',
    tag: 'NYH'
  },
  {
    id: 'teknologi',
    label: 'Teknologi',
    description: 'Ny teknologi for kjøretøy, elbil og fremtidens veier.',
    color: '#3B6FD4',
    tag: 'TEK'
  },
  {
    id: 'sikkerhet',
    label: 'Sikkerhet',
    description: 'Trafikksikkerhet, vinterveier og kjøretips.',
    color: '#E8630A',
    tag: 'SIK'
  },
  {
    id: 'tilbud',
    label: 'Tilbud',
    description: 'Eksklusive tilbud og rabatter for NordPass-abonnenter.',
    color: '#3B6FD4',
    tag: 'TIL'
  }
];

const CategoryCheckboxes = ({ categories, setCategories }) => {
  const toggleCategory = (id) => {
    if (categories?.includes(id)) {
      setCategories?.(categories?.filter((c) => c !== id));
    } else {
      setCategories?.([...(categories || []), id]);
    }
  };

  return (
    <div style={{
      background: '#0A1220',
      border: '1px solid rgba(255,255,255,0.06)',
      padding: '40px',
      position: 'relative',
      overflow: 'hidden',
      marginBottom: '32px'
    }}>
      {/* Color block accent */}
      <div style={{
        position: 'absolute', top: 0, left: 0,
        width: '4px', height: '100%',
        background: 'linear-gradient(to bottom, #E8630A, #3B6FD4, #E8630A)'
      }} />

      {/* Background texture number */}
      <div style={{
        position: 'absolute', right: '-10px', top: '-20px',
        fontFamily: 'Impact, Arial Black, sans-serif',
        fontSize: '120px', fontWeight: 900,
        color: 'rgba(59,111,212,0.04)',
        lineHeight: 1, userSelect: 'none', pointerEvents: 'none'
      }}>03</div>

      <div style={{ paddingLeft: '20px', position: 'relative', zIndex: 1 }}>
        <div style={{
          fontFamily: 'Syne, sans-serif',
          fontSize: '0.65rem', fontWeight: 700,
          color: '#E8630A', letterSpacing: '0.2em',
          textTransform: 'uppercase', marginBottom: '12px'
        }}>STEG 03 — INNHOLDSKATEGORIER</div>

        <div style={{
          fontFamily: 'Impact, Arial Black, sans-serif',
          fontSize: 'clamp(22px, 3vw, 32px)',
          fontWeight: 900, color: '#EEF0F2',
          letterSpacing: '-0.02em', textTransform: 'uppercase',
          marginBottom: '8px'
        }}>HVA INTERESSERER DEG?</div>

        <p style={{
          fontFamily: 'Georgia, serif', fontStyle: 'italic',
          fontSize: '0.9375rem', color: 'rgba(138,149,163,0.7)',
          lineHeight: 1.6, marginBottom: '32px', maxWidth: '480px'
        }}>
          Velg emnene du vil motta innhold om. Du kan endre dette når som helst.
        </p>

        {/* Category grid */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))',
          gap: '14px'
        }}>
          {CATEGORIES?.map((cat, index) => {
            const isChecked = categories?.includes(cat?.id);
            const isEven = index % 2 === 0;
            return (
              <button
                key={cat?.id}
                onClick={() => toggleCategory(cat?.id)}
                style={{
                  padding: '20px',
                  background: isChecked
                    ? `rgba(${cat?.color === '#E8630A' ? '232,99,10' : '59,111,212'},0.1)`
                    : 'rgba(255,255,255,0.02)',
                  border: `1px solid ${isChecked ? cat?.color : 'rgba(255,255,255,0.07)'}`,
                  cursor: 'pointer',
                  textAlign: 'left',
                  transition: 'all 200ms ease',
                  position: 'relative',
                  overflow: 'hidden',
                  transform: isEven ? 'rotate(-0.3deg)' : 'rotate(0.3deg)'
                }}
                onMouseEnter={(e) => {
                  if (!isChecked) e.currentTarget.style.borderColor = 'rgba(255,255,255,0.18)';
                  e.currentTarget.style.transform = 'rotate(0deg) scale(1.01)';
                }}
                onMouseLeave={(e) => {
                  if (!isChecked) e.currentTarget.style.borderColor = 'rgba(255,255,255,0.07)';
                  e.currentTarget.style.transform = isEven ? 'rotate(-0.3deg)' : 'rotate(0.3deg)';
                }}
              >
                {/* Diagonal cut accent */}
                <div style={{
                  position: 'absolute', top: 0, right: 0,
                  width: '0', height: '0',
                  borderStyle: 'solid',
                  borderWidth: '0 28px 28px 0',
                  borderColor: `transparent ${isChecked ? cat?.color : 'rgba(255,255,255,0.06)'} transparent transparent`,
                  transition: 'border-color 200ms ease'
                }} />

                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '14px' }}>
                  {/* Custom checkbox */}
                  <div style={{
                    width: '20px', height: '20px', minWidth: '20px',
                    marginTop: '2px',
                    background: isChecked ? cat?.color : 'rgba(255,255,255,0.04)',
                    border: `2px solid ${isChecked ? cat?.color : 'rgba(255,255,255,0.15)'}`,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    transition: 'all 200ms ease',
                    flexShrink: 0
                  }}>
                    {isChecked && (
                      <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="square">
                        <polyline points="20 6 9 17 4 12" />
                      </svg>
                    )}
                  </div>

                  <div style={{ flex: 1 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
                      <div style={{
                        fontFamily: 'Syne, sans-serif',
                        fontSize: '0.875rem', fontWeight: 800,
                        color: isChecked ? cat?.color : '#EEF0F2',
                        letterSpacing: '-0.01em',
                        transition: 'color 200ms ease'
                      }}>{cat?.label}</div>
                      <div style={{
                        fontFamily: 'JetBrains Mono, monospace',
                        fontSize: '0.55rem', fontWeight: 700,
                        color: cat?.color, letterSpacing: '0.12em',
                        background: `rgba(${cat?.color === '#E8630A' ? '232,99,10' : '59,111,212'},0.12)`,
                        padding: '2px 6px',
                        opacity: isChecked ? 1 : 0.5,
                        transition: 'opacity 200ms ease'
                      }}>{cat?.tag}</div>
                    </div>
                    <div style={{
                      fontFamily: 'Georgia, serif', fontStyle: 'italic',
                      fontSize: '0.8125rem', color: 'rgba(138,149,163,0.6)',
                      lineHeight: 1.5
                    }}>{cat?.description}</div>
                  </div>
                </div>
              </button>
            );
          })}
        </div>

        {/* Selection count */}
        <div style={{
          marginTop: '20px',
          fontFamily: 'JetBrains Mono, monospace',
          fontSize: '0.75rem',
          color: 'rgba(138,149,163,0.5)',
          letterSpacing: '0.05em'
        }}>
          {categories?.length || 0} av {CATEGORIES?.length} kategorier valgt
        </div>
      </div>
    </div>
  );
};

export default CategoryCheckboxes;
